import apiService from '@sonifi/wb-core/services/api.service';
import {
  getProductsSettings,
  getSettingByProduct,
} from '@sonifi/wb-products/services/products.service';
import { PRODUCTS_KEYS } from '@sonifi/wb-products/constants/wbProductsConstants';
import { ENDPOINTS } from '@sonifi/wb-core/services/endpointsConstants';
import {
  processFiles,
  uploadFiles,
} from '@sonifi/wb-widget/services/file/file.service';
import { setAlert } from '@sonifi/wb-notifier/store/notifierSlice';
import {
  cleanGuestRequestSettingsSlice,
  setIsSettingsDirty,
  setSaveInProgress,
  setSettings,
} from '../../store/settings/guestRequestSettingsSlice';
import {
  getLatestImportJob,
  getLatestSynchronizeJob,
  saveGuestRequestJobs,
} from './grSettingsJobs.service';
import { buildFilesErrorMessage } from '@sonifi/wb-widget/services/file/fileHelper';

const getServiceCenterSettings = async (groupUri) => {
  try {
    const res = await apiService.get(
      `${ENDPOINTS.SERVICE_CENTER_SETTINGS}?group=${groupUri}`,
    );
    const serviceCenterSettins = res.data.objects?.length
      ? res.data.objects[0]
      : null;
    return serviceCenterSettins;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const initGuestRequestSettings =
  (groupId) => async (dispatch, getState) => {
    dispatch(cleanGuestRequestSettingsSlice());
    dispatch(setIsSettingsDirty(false));
    const {
      groups: { selectedGroup },
    } = getState();
    await dispatch(getProductsSettings(groupId));
    const settings = dispatch(
      getSettingByProduct({ groupId, productKey: PRODUCTS_KEYS.GUEST_REQUEST }),
    );

    const serviceCenterSettings = await getServiceCenterSettings(
      selectedGroup.uri,
    );
    const emailDelivery = settings.delivery_method === 'email';
    const synchronizes = settings.synchronizes === true;
    const latestImportJob = await getLatestImportJob(groupId);
    const latestSynchronizeJob = await getLatestSynchronizeJob(selectedGroup);
    dispatch(
      setSettings({
        emailDelivery,
        latestImportJob,
        latestSynchronizeJob,
        productSettings: settings,
        serviceCenterSettings,
        synchronizes,
      }),
    );
  };

export const validSettingsFile = (file) => (dispatch) => {
  const filesProcessed = processFiles({
    fileList: [file],
    mimeTypes: [
      'text/csv',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ],
    fileExts: ['.csv, .xls', '.xlsx'],
  });

  if (filesProcessed.rejected.length) {
    const rejectedFilesMessage = buildFilesErrorMessage(filesProcessed.rejected);

    dispatch(
      setAlert({
        content: rejectedFilesMessage,
        type: 'danger',
        show: true,
        dismissable: true,
      }),
    );

    return false;
  }
  return true;
};

export const saveGuestRequestEmailDelivery =
  () => async (dispatch, getState) => {
    dispatch(setSaveInProgress(true));
    try {
      const {
        guestRequestSettings: { serviceCenterSettings, notificationEmails },
      } = getState();
      const body = {
        email_addresses: notificationEmails,
        group: serviceCenterSettings.group,
        id: serviceCenterSettings.id,
        uri: serviceCenterSettings.uri,
        vendor_issue_map: serviceCenterSettings.vendor_issue_map,
      };
      const url = `${ENDPOINTS.SERVICE_CENTER_SETTINGS}/${serviceCenterSettings.id}`;
      await apiService.patch(url, body);
      dispatch(setSaveInProgress(false));
      dispatch(setIsSettingsDirty(false));
      dispatch(
        setAlert({
          title: 'Settings Saved',
          content: 'These settings have been successfully saved.',
          type: 'success',
          show: true,
          dismissable: true,
        }),
      );
    } catch (error) {
      dispatch(setSaveInProgress(false));
      dispatch(
        setAlert({
          title: 'Setting Save Failed',
          content: 'These settings could not be saved.',
          type: 'danger',
          show: true,
          dismissable: true,
        }),
      );
    }
  };

export const saveGuestRequestCsv =
  ({ file }) =>
  async (dispatch, getState) => {
    dispatch(setSaveInProgress(true));
    try {
      const {
        groups: { selectedGroup },
      } = getState();
      const fRes = await dispatch(
        uploadFiles({
          files: { accepted: [file], rejected: [] },
        }),
      );
      const fileRes = fRes.accepted[0]; // Uploading one file
      await saveGuestRequestJobs({ file: fileRes, groupId: selectedGroup.id });
      dispatch(setSaveInProgress(false));
      await dispatch(initGuestRequestSettings(selectedGroup.id));
      dispatch(
        setAlert({
          title: 'Import File Saved',
          content: 'The import file has been uploaded',
          type: 'success',
          show: true,
          dismissable: true,
        }),
      );
    } catch (error) {
      dispatch(
        setAlert({
          title: 'Import File Save Failed',
          content: 'There was an error uploading the import file.',
          type: 'danger',
          show: true,
          dismissable: true,
        }),
      );
      dispatch(setSaveInProgress(false));
    }
  };
